<template>
  <component
    :is="component"
    tabindex="0"
    :class="classes"
    exact
    tag="button"
    :to="to"
    active-class="asd20-tab--active"
  >
    <asd20-icon v-if="icon" :name="icon" size="sm" />
    <span v-if="label" class="asd20-tab__label" v-html="label"></span>
    <asd20-badge v-if="badge" :value="badge" static />
    <slot />
  </component>
</template>

<script>
import Asd20Icon from '../../../components/atoms/Asd20Icon'
import Asd20Badge from '../../../components/atoms/Asd20Badge'

export default {
  name: 'Asd20Tab',

  components: {
    Asd20Badge,
    Asd20Icon,
  },

  props: {
    label: { type: String, default: '', required: true },
    icon: { type: String, default: '' },
    badge: { type: Number, default: 0 },
    pushRight: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    to: { default: '' },
  },

  computed: {
    component() {
      if (this.$router && this.to) return 'router-link'
      return 'button'
    },
    classes() {
      return {
        'asd20-tab': true,
        'asd20-tab--active': this.active,
        'asd20-tab--push-right': this.pushRight,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-tab {
  border: none;
  background: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  font-size: 1rem;
  padding: 0 space(0.75);
  height: space(2);
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-weight: bold;
  color: currentColor;
  border-radius: var(--website-shape__radius-s);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  .asd20-icon {
    margin-right: space(0.25);
  }

  .asd20-badge {
    margin-left: space(0.5);
  }

  &:hover {
    background: var(--website-page__background-color);
  }

  &:focus {
    // outline: none;
    // box-shadow: 0 0 0 5px var(--website-page__link-color) inset;
  }

  &--active {
    background: var(--website-page__background-color);
    color: var(--website-page__title-color);
    &:hover {
      background: white;
    }
    &:focus {
      // box-shadow: 0 0 0 5px var(--website-page__link-color);
      outline: none !important;
    }
  }

  &--push-right {
    margin-left: auto;
  }
}
</style>
